module.exports = __webpack_public_path__ + "static/media/lectures.49383915.svg";